import { manageGroup } from 'core/permissions';

export default {
  global: manageGroup,
  local: 'reporting.activity_report_local',
  local_managed: 'reporting.activity_report_local_managed',
};
